import React from 'react';

import type { DetailPriceRowProps } from './types';

import styles from './styles.module.scss';

export const DetailPriceRow: React.FC<DetailPriceRowProps> = ({ label, value, className }) => {
  const rootClass = [styles.root, className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};
